import AppText from "../../_shared/components/AppText";
import { useLocation, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import useRestList from "../../_shared/hooks/useRestList";

import BackIcon from "../../_shared/components/BackIcon";
import CloseIcon from "../../_shared/components/CloseIcon";

import AppButton from "../../_shared/components/AppButton";

import SlideImages from "../../_shared/components/SlideImages";
import HtmlText from "../../_shared/components/HtmlText";
import { Modal } from "antd";
import SideMenu from "../../_shared/components/SideMenu";
import FinishesPage from "../../_shared/components/FinishesPage";
import HeaderActions from "../../_shared/components/HeaderActions";

function SlideProducts(props) {
  const { setSplash } = props;
  useEffect(() => setSplash(false), []);
  const { id } = useParams();
  const [selectedIndexProduct, setSelectedIndexProduct] = useState(0);

  const [selectedIndexCFCat, setSelectedIndexCFCat] = useState();

  const [selectedIndexCF, setSelectedIndexCF] = useState();

  const [selectedCF, setSelectedCF] = useState();
  const [selectedCFIndex, setSelectedCFIndex] = useState(0);

  const [products, setProducts] = useState();
  const [category, setCategory] = useState();

  const [openSelectedFinishesProduct, setOpenSelectedFinishesProduct] =
    useState(false);
  const [openSelectedFinishesVersion, setOpenSelectedFinishesVersion] =
    useState(false);
  const [openSize, setOpenSize] = useState(false);

  const [allProducts] = useRestList("/products", null, {
    category: id,
  });
  const [allCategories] = useRestList("/categories", null, {
    id: id,
  });

  const headerLabelsCat = (index, field) => {
    return (
      <div style={{ minHeight: 25 }}>
        <AppButton
          onClick={() =>
            selectedIndexCFCat === index
              ? setSelectedIndexCFCat(null)
              : field?.images?.[0]
              ? setSelectedCF(field)
              : setSelectedIndexCFCat(index)
          }
        >
          <div className="row">
            <AppText small bold>
              {">"}
            </AppText>

            <AppText underline bold small>
              {field?.name.it}
            </AppText>
            <AppText underline light small>
              / {field?.name.en}
            </AppText>
          </div>

          {selectedIndexCFCat === index && (
            <HtmlText text={field?.text}></HtmlText>
          )}
        </AppButton>
      </div>
    );
  };

  const headerLabels = (index, field) => {
    return (
      <div style={{ minHeight: 25 }}>
        <AppButton
          onClick={() =>
            selectedIndexCF === index
              ? setSelectedIndexCF(null)
              : setSelectedIndexCF(index)
          }
        >
          <div className="row">
            <AppText small bold>
              {">"}
            </AppText>

            <AppText underline bold small>
              {field?.name.it}
            </AppText>
            <AppText underline light small>
              / {field?.name.en}
            </AppText>
          </div>

          {selectedIndexCF === index && (
            <div style={styles.finMargin}>
              <HtmlText text={field?.text}></HtmlText>
            </div>
          )}
        </AppButton>
      </div>
    );
  };

  useEffect(() => {
    setProducts(
      allProducts.filter(
        (x) =>
          x?.category?.parentCategory === category?.id ||
          x?.category?.id === category?.id
      )
    );
  }, [allProducts]);
  useEffect(() => {
    setCategory(allCategories.find((x) => x?.id === id.toString()));
  }, [id, allCategories]);

  return (
    <div className="rootMenu">
      <SideMenu></SideMenu>
      <div className="rootContent">
        {/* category name */}

        <div className="row" style={{ minHeight: "8%" }}>
          <div>
            <div
              className="row"
              style={{
                marginLeft: 10,
                justifyContent: "space-between",
                width: "85vw",
              }}
            >
              <div>
                <div className="row">
                  <BackIcon></BackIcon>
                  <div>
                    <div className="row">
                      <AppText big bold>
                        {category?.parentCategory?.name?.it}
                      </AppText>
                      <AppText big>
                        {" "}
                        / {category?.parentCategory?.name?.en}
                      </AppText>
                    </div>
                    {!category?.hideNameInApp &&
                       <div className="row">
                      <AppText bold>{category?.name?.it}</AppText>
                      <AppText>/ {category?.name?.en}</AppText>
                    </div>
                    }
                  </div>
                </div>
              </div>

              <HeaderActions></HeaderActions>
            </div>
          </div>
        </div>
        {/* category custom fields */}
        <div style={{ minHeight: "8%", marginLeft: 40 }}>
          {category?.customField?.map((cf, index) => {
            return headerLabelsCat(index, cf);
          })}
          <AppButton onClick={() => setOpenSelectedFinishesProduct(true)}>
            <div className="row" style={{ marginTop: 10 }}>
              <AppText small bold>
                >
              </AppText>
              <AppText small underline bold>
                finiture
              </AppText>
              <AppText small light underline>
                {" "}
                / finishes
              </AppText>
            </div>
          </AppButton>
        </div>
        {/* products  */}
        {products && (
          <div className="row">
            <div
              style={{
                maxWidth: "65%",
                marginLeft: 40,
                marginTop: 30,
              }}
            >
              {/* slide images  */}
              <SlideImages
                image={products?.[selectedIndexProduct]?.image}
                onPlus={() =>
                  selectedIndexProduct === products?.length - 1
                    ? setSelectedIndexProduct(0)
                    : setSelectedIndexProduct(selectedIndexProduct + 1)
                }
                onMinus={() =>
                  selectedIndexProduct === 0
                    ? setSelectedIndexProduct(products?.length - 1)
                    : setSelectedIndexProduct(selectedIndexProduct - 1)
                }
                showArrows={products?.length > 1}
                style={{ maxWidth: "50vw", maxHeight: "70vh" }}
              ></SlideImages>
            </div>

            {/* product details  */}
            <div
              style={{
                width: "30%",
                minHeight: "100%",
                marginLeft: 40,
                marginTop: 30,
              }}
            >
              <div style={{ height: "15%" }}>
                <div className="row">
                  <AppText
                    style={{
                      color:
                        products?.[selectedIndexProduct]?.parentRoom === "0"
                          ? "#d89d30"
                          : "#8b8a79",
                    }}
                    bold
                  >
                    {products?.[selectedIndexProduct]?.name?.it}
                  </AppText>
                </div>
                <div className="row">
                  <AppText
                    style={{
                      color:
                        products?.[selectedIndexProduct]?.parentRoom === "0"
                          ? "#d89d30"
                          : "#8b8a79",
                    }}
                    bold
                    small
                  >
                    {products?.[selectedIndexProduct]?.description?.it}
                  </AppText>
                  <AppText
                    style={{
                      color:
                        products?.[selectedIndexProduct]?.parentRoom === "0"
                          ? "#d89d30"
                          : "#8b8a79",
                    }}
                    small
                  >
                    / {products?.[selectedIndexProduct]?.description?.en}
                  </AppText>
                </div>
              </div>
              <div
                style={{
                  height: "20%",
                }}
              >
                <div className="row">
                  <AppText small bold>
                    Dettagli composizione
                  </AppText>
                  <AppText small light>
                    / Composition details
                  </AppText>
                </div>
                <div>
                  {products?.[selectedIndexProduct]?.customField?.map(
                    (cf, index) => {
                      return headerLabels(index, cf);
                    }
                  )}
                  <AppButton
                    onClick={() =>
                      setOpenSelectedFinishesVersion(
                        !openSelectedFinishesVersion
                      )
                    }
                  >
                    <div className="row" style={{ marginTop: 10 }}>
                      <AppText small bold>
                        >
                      </AppText>
                      <AppText small underline bold>
                        finiture
                      </AppText>
                      <AppText small light underline>
                        {" "}
                        / finishes
                      </AppText>
                    </div>
                  </AppButton>

                  <div style={styles.finMargin}>
                    {openSelectedFinishesVersion &&
                      products?.[selectedIndexProduct]?.finishes.map((fin) => (
                        <div className="row">
                          <AppText small bold>
                            {fin?.name?.it}
                          </AppText>
                          <AppText small>/ {fin?.name?.en}</AppText>
                        </div>
                      ))}
                    {openSelectedFinishesVersion &&
                      products?.[selectedIndexProduct]?.fabrics.map(
                        (fabric) => (
                          <div className="row">
                            <AppText bold small>
                              {fabric?.name?.it}{" "}
                              {fabric?.parentFabric?.name?.it}
                            </AppText>
                            {fabric?.name?.en && (
                              <AppText small>
                                / {fabric?.name?.en}{" "}
                                {fabric?.parentFabric?.name?.en}
                              </AppText>
                            )}
                          </div>
                        )
                      )}
                  </div>
                  <AppButton onClick={() => setOpenSize(!openSize)}>
                    <div className="row" style={{ marginTop: 10 }}>
                      <AppText small bold>
                        >
                      </AppText>
                      <AppText small underline bold>
                        dimensioni
                      </AppText>
                      <AppText small light underline>
                        {" "}
                        / dimensions
                      </AppText>
                    </div>
                  </AppButton>

                  <div style={styles.finMargin}>
                    {openSize && (
                      <HtmlText
                        text={products?.[selectedIndexProduct]?.size}
                      ></HtmlText>
                    )}
                  </div>
                </div>
              </div>
              <div
                style={{
                  height: "65%",
                  display: "flex",
                  alignItems: "flex-end",
                }}
              >
                <img
                  src={products?.[selectedIndexProduct]?.details?.[0]}
                  style={{
                    height: 100,
                  }}
                  alt=""
                ></img>
              </div>
            </div>
          </div>
        )}
        <Modal
          open={selectedCF}
          closable={false}
          footer={[]}
          centered
          bodyStyle={{ height: "85vh", overflowY: "auto" }}
          className="modal"
        >
          <div>
            <div
              style={{
                display: "flex",
                marginBottom: 4,
                justifyContent: "space-between",
              }}
            >
              <div className="row">
                <AppText bold>{selectedCF?.name?.it}</AppText>
                <AppText light>/ {selectedCF?.name?.en}</AppText>
              </div>
              <div>
                <CloseIcon onClick={() => setSelectedCF()}></CloseIcon>
              </div>
            </div>

            <SlideImages
              image={selectedCF?.images[selectedCFIndex]}
              onPlus={() =>
                selectedCFIndex < selectedCF?.images.length - 1
                  ? setSelectedCFIndex(selectedCFIndex + 1)
                  : setSelectedCFIndex(0)
              }
              onMinus={() =>
                selectedCFIndex !== 0
                  ? setSelectedCFIndex(selectedCFIndex - 1)
                  : setSelectedCFIndex(selectedCF?.images.length - 1)
              }
              style={{ maxWidth: "100%", maxHeight: "75vh" }}
              showArrows={selectedCF?.images?.length > 1}
            ></SlideImages>
          </div>
        </Modal>
        <Modal
          open={openSelectedFinishesProduct}
          closable={false}
          footer={[]}
          centered
          className="modal"
          bodyStyle={{ height: "85vh", overflowY: "auto" }}
        >
          <FinishesPage
            finishes={category?.finishes}
            onClose={() => setOpenSelectedFinishesProduct(false)}
          ></FinishesPage>
        </Modal>
      </div>
    </div>
  );
}
const styles = {
  finMargin: { marginLeft: 10 },
};

export default SlideProducts;
